/**
 * Constants for SLAM Sports AI - College Recruiter Analysis System
 * Ported from theWIRE/SLAMPitchDashboard/lib/constants.ts
 *
 * @module constants
 */

// File size limit for uploads (100MB for batch video analysis)
export const MAX_FILE_SIZE_MB = 100;

// Accepted media types for uploads
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const ACCEPTED_VIDEO_TYPES = ['video/mp4', 'video/webm', 'video/quicktime'];
export const ACCEPTED_CSV_TYPES = ['text/csv', 'application/vnd.ms-excel'];

// Document types - Gemini native (no conversion needed)
export const ACCEPTED_DOCUMENT_TYPES = [
  'application/pdf',
  'text/plain',
];

// XML types - Gemini native support
export const ACCEPTED_XML_TYPES = [
  'text/xml',
  'application/xml',
];

// Office formats requiring conversion to text before Gemini processing
export const CONVERTIBLE_DOCUMENT_TYPES = [
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // .xlsx
  'application/msword',                                                       // .doc
  'application/vnd.ms-excel',                                                 // .xls (not CSV)
];

// All supported context file types
export const ALL_CONTEXT_TYPES = [
  ...ACCEPTED_DOCUMENT_TYPES,
  ...ACCEPTED_XML_TYPES,
  ...CONVERTIBLE_DOCUMENT_TYPES,
];

// File extensions for context files
export const CONTEXT_FILE_EXTENSIONS = ['.pdf', '.txt', '.docx', '.xlsx', '.doc', '.xls', '.xml'];

// Gemini-native file types (no conversion needed)
export const GEMINI_NATIVE_TYPES = [
  ...ACCEPTED_IMAGE_TYPES,
  ...ACCEPTED_VIDEO_TYPES,
  'application/pdf',
  'text/plain',
  'text/xml',
  'application/xml',
];

// SLAM Brand Colors
export const SLAM_COLORS = {
  gold: '#FFD700',
  goldHover: '#FFC000',
  dark: '#0a0a0a',
  surface: '#141414',
  text: '#F4F4F5',
  textMuted: '#A1A1AA',
};

export default {
  MAX_FILE_SIZE_MB,
  ACCEPTED_IMAGE_TYPES,
  ACCEPTED_VIDEO_TYPES,
  ACCEPTED_CSV_TYPES,
  ACCEPTED_DOCUMENT_TYPES,
  ACCEPTED_XML_TYPES,
  CONVERTIBLE_DOCUMENT_TYPES,
  ALL_CONTEXT_TYPES,
  CONTEXT_FILE_EXTENSIONS,
  GEMINI_NATIVE_TYPES,
  SLAM_COLORS,
};
